import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const wellnessAcknowledgementReducer = combineReducers({
  list,
  view,
});

export default wellnessAcknowledgementReducer;
